import React from 'react';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const FlareButton = () => {
  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        Boosted by USD₮0 on Flare&nbsp;
        <span className="small"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>
        Flare is building the DeFi ecosystem for XRP, with USD₮0 on Flare as the essential capital base.
      </Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href="https://api.xrpscan.com/api/v1/campaign/flarebutton"
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >XRPFi on Flare</Button>
        </OverlayTrigger>
    </span>
  )
}

export default FlareButton;
